import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49edc952"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-microchip-ai" }, null, -1))
const _hoisted_2 = { class: "popout-text-footer-container" }
const _hoisted_3 = { class: "footer-right" }

import { computed, onMounted, onUnmounted, PropType, ref, watch } from "vue";
import { DxButton, DxTextArea } from "devextreme-vue";
import { TimeStamps } from "@/utils/TimeStamp";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { sizes, subscribe, unsubscribe } from "@/utils/media-query";
import AiTextGeneratorModal from "@/components/ai/ai-text-generator-modal.vue";
import { FieldValidation } from "acquaint-api/validation/FieldValidation";
import { displayMarkdownStandardInfoAlert } from "@/alerts/standardInfoAlert";


export default /*#__PURE__*/_defineComponent({
  __name: 'acquaint-popout-text-area',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {Boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * The validation rules applied to the field.
   * @type {FieldValidation}
   * @required
   */
  fieldValidation: {
    type: Object as PropType<FieldValidation>,
    required: true,
  },
  /**
   * The content of the text
   * @type {String}
   * @required
   */
  content: {
    type: String,
    required: true,
  },
  /**
   * The label displayed for the control.
   * @type {String}
   * @default ''
   */
  label: {
    type: String,
    default: "",
  },
  /**
   * Determines whether to display AI modal.
   * @type {boolean}
   * @default false
   */
  displayAIButton: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  "update:modelValue",
  "update:content",
  "aiIconClick",
],
  setup(__props, { emit }) {

const props = __props;



const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const content = ref("");



const textAreaRef = ref();
const wrapperRef = ref();
const hasScrollbar = ref(false);
const isMobile = ref(false);
const displayAIModal = ref(false);
const displayCancelConfirmationModal = ref(true);
const keepModalOpen = ref(false);

onMounted(() => {
  focusInput();
  updateIsMobile();
  subscribe(updateIsMobile);
  content.value = props.content;
});

onUnmounted(() => {
  unsubscribe(updateIsMobile);
});

watch(
  () => props.modelValue,
  (value) => {
    if (value) {
      if (!keepModalOpen.value) content.value = props.content;
      else keepModalOpen.value = false;
      focusInput();
    }
  },
);

const updateIsMobile = () => {
  const breakpoints = sizes();
  isMobile.value = breakpoints["screen-x-small"] === true;
};

const focusInput = () => {
  textAreaRef.value?.instance?.focus();
};
const onFocusOut = () => (content.value = content.value.trim());

const addTimeStamp = async () => {
  const stamped = await TimeStamps(content.value);
  content.value = truncateToMaxLength(stamped);
  focusInput();
};

const applyAIResponse = async (aiText: string) => {
  content.value = truncateToMaxLength(aiText);
};

const truncateToMaxLength = (value: string) => {
  const max = props.fieldValidation.maxLength;
  if (!max) return value;
  if (value.length <= max) return value;
  displayMarkdownStandardInfoAlert(
    `Your text is over the maximum character limit (<b>${props.fieldValidation.maxLength}</b>), and has been trimmed to fit.`,
  );
  return value.slice(0, max);
};

const charactersRemaining = computed(() => {
  const max = props.fieldValidation.maxLength;
  if (!max) return null;
  return max - (content.value?.length ?? 0);
});

watch(
  () => content.value,
  () => {
    checkScrollbar();
  },
);

const checkScrollbar = () => {
  setTimeout(() => {
    if (!wrapperRef.value) return;
    const el = wrapperRef.value.querySelector(
      ".dx-textarea textarea",
    ) as HTMLElement;
    if (!el) return;
    hasScrollbar.value = el.scrollHeight > el.clientHeight;
  }, 5);
};

const doneClick = () => {
  emit("update:content", content.value);
  keepModalOpen.value = false;
  displayCancelConfirmationModal.value = false;
  showModal.value = false;
};

const modalClosed = () => {
  displayCancelConfirmationModal.value = true;
  // showModal.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModalBase, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showModal).value = $event)),
      title: props.label,
      showCloseConfirmationPrompt: displayCancelConfirmationModal.value,
      onCancelPromptDenied: _cache[5] || (_cache[5] = ($event: any) => (keepModalOpen.value = true)),
      onModalClosed: modalClosed,
      height: "550px"
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", {
          class: "textbox-container textarea-wrapper",
          ref_key: "wrapperRef",
          ref: wrapperRef
        }, [
          _createVNode(_unref(DxTextArea), {
            ref_key: "textAreaRef",
            ref: textAreaRef,
            value: content.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((content).value = $event)),
            "max-length": props.fieldValidation.maxLength,
            "value-change-event": "input",
            height: "420px",
            width: "100%",
            onFocusOut: onFocusOut,
            onKeyUp: checkScrollbar
          }, null, 8, ["value", "max-length"]),
          true
            ? (_openBlock(), _createBlock(_unref(DxButton), {
                key: 0,
                class: _normalizeClass(["ai-button-container", { 'with-scrollbar': hasScrollbar.value && !isMobile.value }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (displayAIModal.value = true))
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }, 8, ["class"]))
            : _createCommentVNode("", true)
        ], 512),
        _createElementVNode("section", _hoisted_2, [
          _createVNode(_unref(DxButton), {
            text: "Date Stamp",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (addTimeStamp())),
            disabled: !charactersRemaining.value
          }, null, 8, ["disabled"]),
          _createElementVNode("div", _hoisted_3, [
            (charactersRemaining.value !== null)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(["char-count", {
              warning:
                charactersRemaining.value <= props.fieldValidation.maxLength * 0.1,
              error: charactersRemaining.value <= 0,
            }])
                }, _toDisplayString(charactersRemaining.value), 3))
              : _createCommentVNode("", true),
            _createVNode(_unref(DxButton), {
              text: "Done",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (doneClick()))
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title", "showCloseConfirmationPrompt"]),
    _createVNode(AiTextGeneratorModal, {
      modelValue: displayAIModal.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((displayAIModal).value = $event)),
      "display-apply-button": true,
      onApplyAIResponse: applyAIResponse
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})